export default "__VITE_ASSET__DFhNJsDn__"